import htmlRetriever from '../../core/services/html-retriever/html-retriever'

export default {
  videos: htmlRetriever.getElementContent('#videoconfig'),
}
